// @flow
import React from 'react';
import PropTypes from 'prop-types';

import './SideNav.scss';

type Props = {
  children: Array<Element> | Object,
};

/**
 * The navigation component that sits at the side of the page.
 */
const SideNavComponent = (props: Props) => (
  <nav className="side-nav-component">
    <ul className="side-nav-component__container list-bare">{props.children}</ul>
    <div className="grey-out-hack" />
  </nav>
);

SideNavComponent.displayName = 'SideNav';

SideNavComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default SideNavComponent;
